import React, { Component } from "react";
import { SpinnerLoader } from "@my-dld/components/SpinnerLoader";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { TenantContractContext } from "@eres/ejari-core/contexts/TenantContractContext";

interface Props extends RoutedViewProps {
	to: string;
	done: string;
}

class TCProcessMarker extends Component<Props> {
	static contextType = TenantContractContext;
	context!: React.ContextType<typeof TenantContractContext>;

	componentDidMount() {
		if ( this.context.actionDone ) {
			this.props.history.replace( this.props.done );
		} else {
			this.props.history.push( this.props.to );
		}
	}

	render() {
		return (
			<div style={ { minHeight: 400 } } className={ "d-flex " }>
				<SpinnerLoader/>
			</div>
		);
	}
}

export default TCProcessMarker;
